export default class Node{

	constructor(topic, information, url, parent, children){
		this.topic=topic;
		this.information=information;
		this.url=url;
		this.parent=parent;
		this.children=[];
		//this.setInformation(information);
		this.setChildren(children);
	}

	setChildren(children){
		//console.log(children);
		if(children!==undefined){
			children.forEach((child, i)=>{

				//console.log(child);
				this.setChild(new Node(child.topic, child.information, child.url, this, child.topics));
			});
		}
	}

	/*setInformation(information){
		information.forEach((info, i)=>{
			this.information.push(info);
		});
	}*/

	getTopic(){
		return this.topic;
	}

	getInformation(){
		return this.information;
	}

	getUrl(){
		return this.url;
	}
	
	getParent(){
		return this.parent;
	}

	getChildren(){
		return this.children;
	}

	setChild(child){
		this.children.push(child);

	}
}